const KNOWN_API_ERROR_CODE =
  /\b(ADVISOR_PRODUCT_SELLER_DUPLICATE|PRODUCT_RANGE_DUPLICATE|DISCOUNT_CODE_DUPLICATE|LEAD_TYPOLOGY_DUPLICATE|LEAD_TYPOLOGY_LABEL_REQUIRED|LEAD_TYPOLOGY_IN_USE|CONFLICT|UNAUTHORIZED|NOT_FOUND|FORBIDDEN|SERVER_ERROR)\b/;

const AUTH_STATUS_CODES = [401, 403];

const isAuthConnectionText = (value) => {
  if (typeof value !== "string") return false;
  return (
    /not authorized/i.test(value) ||
    /session expired/i.test(value) ||
    value === "UNAUTHENTICATED" ||
    value === "FORBIDDEN"
  );
};

/**
 * Session ended or the request was rejected before it could run
 * (missing or invalid token). Business errors such as FORBIDDEN stay visible.
 */
export function isAuthConnectionError(error) {
  const statusCode = error?.networkError?.statusCode || error?.statusCode;
  if (AUTH_STATUS_CODES.includes(statusCode)) return true;

  const candidates = [
    error?.networkError?.result,
    error?.networkError?.message,
    error?.message,
    error?.graphQLErrors?.[0]?.message,
    error?.graphQLErrors?.[0]?.extensions?.code,
  ];

  return candidates.some(isAuthConnectionText);
}

/**
 * Maps a GraphQL / network error to a translated API message from errors.json (API.*).
 */
export function resolveApiErrorMessage(error, apiErrors, options = {}) {
  const { duplicateKeyMessageKey = "CONFLICT" } = options;

  const gqlErr = error?.graphQLErrors?.[0];
  const candidates = [
    gqlErr?.message,
    gqlErr?.extensions?.exception?.message,
    error?.message,
  ].filter(Boolean);

  for (const raw of candidates) {
    const s = String(raw).trim();
    if (apiErrors[s]) {
      return apiErrors[s];
    }
    const stripped = s
      .replace(/^GraphQL\s+error:\s*/i, "")
      .replace(/^Error:\s*/i, "")
      .trim();
    if (apiErrors[stripped]) {
      return apiErrors[stripped];
    }
    const match = s.match(KNOWN_API_ERROR_CODE);
    if (match && apiErrors[match[1]]) {
      return apiErrors[match[1]];
    }
    if (/duplicate key/i.test(s) || /duplicate entry/i.test(s)) {
      const dupMsg = apiErrors[duplicateKeyMessageKey];
      if (dupMsg) {
        return dupMsg;
      }
    }
  }

  return apiErrors.GENERIC;
}
